import * as yup from 'yup';

export const ResetUserPasswordSchema = yup.object({
  password: yup
    .string()
    .min(6, 'New password must contain at least 6 characters.')
    .max(16, 'New password must contain at most 16 characters')
    .required('Password is required'),
  passwordConfirm: yup
    .string()
    .required('Confirmation password is required')
    .oneOf([yup.ref('password')], 'Passwords must match'),
});
